declare const window: any;

export type CoralogixVariant = 'fullscreen' | 'widget';

let initialized = false;

export const initCoralogix = (variant: CoralogixVariant): void => {
    if (initialized) return;
    initialized = true;

    const apmEnabled = process.env.REACT_APP_APM_ENABLED === 'true';
    if (!apmEnabled) return;

    const publicKey = process.env.REACT_APP_APM_PUBLIC_KEY || '';
    const application = process.env.REACT_APP_APM_APPLICATION || '';
    const domain = process.env.REACT_APP_APM_DOMAIN || '';
    const version = process.env.REACT_APP_APM_VERSION || '';
    const subsystem = process.env.REACT_APP_APM_SUBSYSTEM || '';
    const environment = process.env.REACT_APP_APM_ENVIRONMENT || '';
    const sampleRateRaw = process.env.REACT_APP_APM_SESSION_SAMPLE_RATE || '';

    if (!publicKey || !application || !domain) {
        console.warn(
            'Coralogix: required REACT_APP_APM_* env vars missing — skipping init'
        );
        return;
    }

    let sessionSampleRate = parseInt(sampleRateRaw, 10);
    if (isNaN(sessionSampleRate)) sessionSampleRate = 100;

    // Pre-load queue stub: calls made before the SDK script finishes
    // loading are pushed onto `.q` and replayed by the SDK on init.
    window.CoralogixRum =
        window.CoralogixRum ||
        function () {
            (window.CoralogixRum.q = window.CoralogixRum.q || []).push(
                arguments
            );
        };

    const js = document.createElement('script');
    js.src =
        'https://cdn.rum-ingress-coralogix.com/coralogix/browser/2.3.0/coralogix-browser-sdk.js';
    js.async = true;
    js.onload = () => {
        try {
            window.CoralogixRum.init({
                public_key: publicKey,
                application,
                version,
                coralogixDomain: domain,
                sessionSampleRate,
                environment: (environment || 'unknown').toLowerCase(),
                labels: { subsystem, variant },
                // Disable auto-instrumentation — we send only the explicit
                // events emitted via the IAPM wrapper to keep ingest volume
                // (and cost) predictable.
                instrumentations: {
                    errors: false,
                    fetch: false,
                    xhr: false,
                    web_vitals: false,
                    long_tasks: false,
                    interactions: false,
                    resources: false,
                },
            });
        } catch (e) {
            console.error('Coralogix RUM init error:', e);
        }
    };
    document.head.appendChild(js);
};
